import auth from "../middleware/auth";
import admin from "../middleware/admin";

function page(path) {
    return () => import(/* webpackChunkName: '' */ `@/pages/${path}`).then(m => m.default || m)
}

const routes = [
    {
        path: '/',
        name: 'welcome',
        component: page('auth/login.vue'),
        meta: {
            middleware: [auth]
        }
    },

    {
        path: '/login',
        name: 'login',
        component: page('auth/login.vue'),
        meta: {
            middleware: [auth]
        }
    },

    {
        path: '/register',
        name: 'Sign Up',
        component: page('auth/register.vue'),
        // meta: {
        //     middleware: [auth]
        // }
    },
    {
        path: '/password/reset',
        name: 'password.request',
        component: page('auth/password/email.vue'),
        // meta: {
        //     middleware: [auth]
        // }
    },
    {
        path: '/password/reset/:token',
        name: 'password.reset',
        component: page('auth/password/reset.vue'),
        // meta: {
        //     middleware: [auth]
        // }
    },
    {
        path: '/email/verify/:id',
        name: 'verification.verify',
        component: page('auth/verification/verify.vue'),
        // meta: {
        //     middleware: [auth]
        // }
    },
    {
        path: '/email/resend',
        name: 'verification.resend',
        component: page('auth/verification/resend.vue'),
        // meta: {
        //     middleware: [auth]
        // }
    },
    {
        path: '/home',
        name: 'home',
        component: page('home.vue'),
    },
    {
        path: '/account-settings',
        name: 'Manage Account',
        component: page('curlProfile/settings/accountSettings.vue'),
        meta: {
            middleware: [auth]
        }
    },
    {
        path: '/curl-profile',
        name: 'Curl Profile',
        component: page('curlProfile/curlProfileView.vue'),
        meta: {
            middleware: [auth]
        }
    },
    {
        path: '/insights-page',
        name: 'Insights',
        component: page('curlProfile/InsightsPage.vue'),
        meta: {
            middleware: [auth]
        }
    },
    {
        path: '/quiz/curl-profile',
        name: 'profileQuiz',
        component: page('curlProfile/quizes/curlProfileQuiz.vue'),
        // meta: {
        //     middleware: [auth]
        // }
    },
    {
        path: '/hair-regimen',
        name: 'Hair regimen',
        component: page('curlProfile/hairRegimen/hairRegimenView.vue'),
        meta: {
            middleware: [auth]
        }
    },
    {
        path: '/regimen',
        name: 'Regimen Builder',
        component: page('curlProfile/hairRegimen/RegimentBuilder.vue'),
        meta: {
            middleware: [auth]
        }
    },
    {
        path: '/regimen-calendar',
        name: 'Regimen Calendar',
        component: page('curlProfile/hairRegimen/RegimenCalendar.vue'),
        meta: {
            middleware:  [auth]
        }
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: page('curlProfile/profileDashboard.vue'),
        meta: {
            middleware: [auth]
        }
    },
    {
        path: '/regimen-checker',
        name: 'Regimen checker',
        component: page('curlProfile/hairRegimen/regimenChecker.vue'),
        meta: {
            middleware: [auth]
        }
    },
    {
        path: '/curl-notes',
        name: 'Curl Notes',
        component: page('curlProfile/notes/curlNotes.vue'),
        meta: {
            middleware: [auth]
        }
    },
    {
        path: '/create-hair-regimen',
        name: 'Create hair regimen',
        component: page('curlProfile/hairRegimen/createHairRegimen.vue'),
        meta: {
            middleware: [auth]
        }
    },
    {
        path: '/shop',
        name: 'Shop',
        component: page('shop/shopView.vue'),
        meta: {
            middleware: [auth]
        }
    },
    {
        path: '/product/:id',
        name: 'Product',
        component: page('shop/productView.vue'),
        meta: {
            middleware: [auth]
        }
    },
    {
        path: '/checkout',
        name: 'checkout',
        component: page('shop/checkoutView.vue'),
        meta: {
            middleware: [auth]
        }
    },
    {
        path: '/admin',
        name: 'admin',
        component: page('admin/AdminView.vue'),
        children: [
            { path: '',  redirect: { name: 'Admin users' }},
            {
                path: 'users',
                name: 'Admin users',
                component: page('admin/UserList.vue'),
                meta: {
                    middleware: [admin]
                }
            },
            {
                path: 'methods',
                name: 'Admin methods',
                component: page('admin/AdminMethods.vue'),
                meta: {
                    middleware: [admin]
                }
            },
            {
                path: 'insights',
                name: 'Admin insights',
                component: page('admin/AdminInsights.vue'),
                meta: {
                    middleware: [admin]
                }
            },
            {
                path: 'monitoring',
                name: 'Admin monitoring',
                component: page('admin/AdminMonitoring.vue'),
                meta: {
                    middleware: [admin]
                }
            },
            {
                path: 'detail',
                name: 'RegimenDetail',
                component: page('admin/RegimenDetail.vue'),
                meta: {
                    middleware: [admin]
                }
            },
            {
                path: 'regimen',
                name: 'Admin regimen',
                component: page('admin/AdminRegimen.vue'),
                meta: {
                    middleware: [admin]
                }
            },
            {
                path: '/user/:id',
                name: 'user',
                component: page('admin/UserInfo.vue'),
                meta: {
                    middleware: [admin]
                }
            }
        ],
        meta: {
            middleware: [admin],
            isAdmin: true
        }
    },

    {path: '*', component: page('errors/404.vue')}
]

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js